var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadCircle = function SvgUploadCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 23"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#uploadCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.042c5.768 0 10.542-4.785 10.542-10.541C22.042 5.734 17.257.959 11.49.959 5.734.959.96 5.734.96 11.501c0 5.756 4.785 10.541 10.542 10.541m0-1.757a8.74 8.74 0 0 1-8.774-8.784c0-4.878 3.886-8.785 8.764-8.785a8.76 8.76 0 0 1 8.795 8.785 8.75 8.75 0 0 1-8.784 8.784m0-3.617c.455 0 .776-.32.776-.775v-5.167l-.083-2.191 1.054 1.25 1.22 1.24c.134.145.32.228.547.228.424 0 .755-.331.755-.745a.75.75 0 0 0-.217-.537L12.11 6.53c-.196-.197-.382-.29-.61-.29-.216 0-.392.083-.599.29L7.45 9.97c-.134.134-.196.32-.196.537 0 .414.32.745.744.745a.8.8 0 0 0 .548-.228l1.23-1.24 1.033-1.24-.082 2.18v5.168c0 .455.33.775.775.775"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uploadCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h23v23H0z"
  })))));
};
export default SvgUploadCircle;